// Route vocabulary only: importing the navigation must not eagerly load the forum.
export const FORUM_ROUTE_PAIRS = Object.freeze([
  ['Forum', 'ForumNext'], ['ForumThread', 'ForumNextThread'],
  ['ForumSection', 'ForumNextSection'], ['ForumRules', 'ForumNextRules'],
  ['ForumSearch', 'ForumNextSearch'], ['UserActivity', 'ForumNextActivity'],
  ['AdminNeedResponse', 'ForumNextPending']
]);

export function forumExperienceDestination(route, experience) {
  const pair = FORUM_ROUTE_PAIRS.find(names => names.includes(route.name));
  if (!pair) return null;
  const modern = experience === 'modern', query = { ...(route.query || {}) };
  const destination = { name: pair[modern ? 1 : 0] };
  if (pair[0] === 'ForumThread') {
    if (!route.params?.nid) return null;
    destination.params = { nid: String(route.params.nid) };
    let hash = route.hash || '';
    const comment = /^#comment-([1-9]\d*)$/.exec(hash);
    if (query.comment_id === undefined && comment) query.comment_id = comment[1];
    if (query.comment_id !== undefined) { delete query.last; delete query.position; hash = '#comment-' + query.comment_id; }
    else if (modern && query.last === 'true') { query.position = 'last'; delete query.last; }
    else if (!modern && query.position === 'last') { query.last = 'true'; delete query.position; }
    if (modern && hash === '#comment-op') hash = '#topic-' + destination.params.nid;
    if (!modern && hash === '#topic-' + destination.params.nid) hash = '#comment-op';
    if (hash) destination.hash = hash;
  }
  if (pair[0] === 'ForumSection') {
    if (!route.params?.slug) return null;
    destination.params = { slug: route.params.slug };
  }
  if (pair[0] === 'Forum') {
    if (modern) {
      if (query.view === 'valores') query.view = 'values';
      if (query.view === 'index') { query.tab = 'sections'; delete query.view; }
      if (query.view === 'search') { destination.name = 'ForumNextSearch'; delete query.view; }
    } else {
      if (query.view === 'values') query.view = 'valores';
      if (query.tab === 'sections') { query.view = 'index'; delete query.tab; }
    }
  }
  if (pair[0] === 'AdminNeedResponse') {
    const types = { all: 'all', topics: 'topic', comments: 'comment' };
    if (modern) { query.type = types[query.tab] || 'all'; delete query.tab; }
    else { query.tab = Object.keys(types).find(tab => types[tab] === query.type) || 'all'; delete query.type; }
    // Different page sizes: retain the page containing the first visible row.
    if (/^[1-9]\d*$/.test(String(query.page || ''))) query.page = String(Math.floor((Number(query.page) - 1) * (modern ? 10 / 20 : 20 / 10)) + 1);
  }
  const search = pair[0] === 'ForumSearch' || (pair[0] === 'Forum' && route.query?.view === 'search');
  if (search && route.name !== destination.name && typeof query.q === 'string' && query.q.trim()) {
    const validPage = value => typeof value === 'string' && /^[1-9]\d*$/.test(value) && Number.isSafeInteger(Number(value));
    // These result orders are different, not two page sizes of the same list.
    // Preserve a bookmark for each version, scoped to the unchanged criteria.
    const sourcePage = modern ? 'legacy_page' : 'modern_page', targetPage = modern ? 'modern_page' : 'legacy_page';
    query[sourcePage] = validPage(query.page) ? query.page : '1';
    const restore = validPage(query[targetPage]);
    query.page = restore ? query[targetPage] : '1';
    query.experience_search = restore ? 'restored' : 'reset';
  }
  if (Object.keys(query).length) destination.query = query;
  return destination;
}
